// CONSTRAINT: the codes are a wire contract with SubmissionErrorCodes.php and the typed submit exceptions: keep them
// byte-identical. Host-side, never in the renderer: it imports the host vue-i18n singleton.
import i18n from "@/shared/i18n";
export const DONATION_ERROR_CODES = [
    "Submission.Altcha.Invalid",
    "Submission.Altcha.Unavailable",
    "Submission.Body.TooLarge",
    "Submission.RateLimited",
    "TooManyRequests",
    "Form.NotFound",
    "Submission.Form.NotAcceptingSubmissions",
    "Submission.InvalidTransition",
    "Submission.Frequency.NotOffered",
    "Submission.Frequency.NotSupported",
    "Submission.Amount.NotOffered",
    "Submission.CustomAmount.Disabled",
    "Submission.CustomAmount.BelowMinimum",
    "Submission.Currency.NotOffered",
    "Submission.Project.NotEligible",
    "Submission.DonorType.NotOffered",
    "Submission.Phone.Required",
    "Submission.Phone.InternationalFormatRequired",
    "Submission.DonorType.Invalid",
    "Submission.DonorFirstName.Required",
    "Submission.DonorFirstName.TooLong",
    "Submission.DonorLastName.Required",
    "Submission.DonorLastName.TooLong",
    "Submission.DonorEmail.Invalid",
    "Submission.DonorCivility.Invalid",
    "Submission.DonorBirthDate.Invalid",
    "Submission.Address.Line1.Required",
    "Submission.Address.Line1.TooLong",
    "Submission.Address.Line2.TooLong",
    "Submission.Address.PostalCode.Required",
    "Submission.Address.PostalCode.TooLong",
    "Submission.Address.City.Required",
    "Submission.Address.City.TooLong",
    "Submission.Address.Country.Required",
    "Submission.Address.Country.Invalid",
    "Submission.Amount.Invalid",
    "Submission.Currency.Invalid",
    "Submission.Frequency.Invalid",
    "Submission.ProjectId.Invalid",
    "Submission.Organization.Required",
    "Submission.Organization.Unexpected",
    "Submission.Organization.OrgName.Required",
    "Submission.Organization.OrgName.TooLong",
    "Submission.Organization.Siret.Required",
    "Submission.Organization.Siret.TooLong",
    "Submission.Organization.LegalForm.Required",
    "Submission.Organization.LegalForm.TooLong",
    "Submission.Consent.Required",
    "Submission.ReturnUrl.Invalid",
    "Submission.ReturnUrl.NotAllowed",
    "Submission.Orchestration.Failed",
    "InternalServerError",
    "BadRequest",
];
const ALIASED_KEY = {
    TooManyRequests: "Submission.RateLimited",
};
const DEFAULT_FALLBACK_KEY = "donationForm.errors.default";
function isKnownCode(code) {
    return DONATION_ERROR_CODES.includes(code);
}
export function resolveDonationError(errorCode, fallbackKey = DEFAULT_FALLBACK_KEY) {
    const { t, tm } = i18n.global;
    if (!errorCode || !isKnownCode(errorCode)) {
        return t(fallbackKey);
    }
    const keyCode = ALIASED_KEY[errorCode] ?? errorCode;
    // Resolve both shapes: a Tolgee pull nests the dotted codes, a hand-authored bundle may hold flat dotted leaves.
    // Without the nested lookup every code falls back to the generic message once the bundle comes from Tolgee.
    const bundle = tm("donationForm.errors");
    const flat = bundle?.[keyCode];
    if (typeof flat === "string" && flat !== "") {
        return flat;
    }
    const nestedKey = `donationForm.errors.${keyCode}`;
    const nested = t(nestedKey);
    return nested !== nestedKey && nested !== "" ? nested : t(fallbackKey);
}
